

import { Status } from "./Status";
import { Items } from "./Items";
import { Icons } from "./Icons";
import { Contacts } from "./Contacts";
import { Features } from "./Features";
import { Categories } from "./Categories";
import { Routes } from "./Routes";
import { Users } from "./Users";
import { Terms } from "./Terms";
import { Forms } from "./Forms";


export type iDataResult= any[];

export interface iData {
    get(): Promise<iDataResult>;
}


export class Data {

    crmmap: any = false;
    Status: Status = null;
    Items: Items = null;
    Icons: Icons = null;
    Contacts: Contacts = null;
    Features: Features = null;
    Categories: Categories = null;
    Routes: Routes = null;
    Users: Users = null;
    Terms: Terms = null;
    Forms: Forms = null;

    //this.cache is not in this parent class, becuase each child
    //might handle the cache differnly 
    //oh and i know this is not th parent class (but i need to create one)
    constructor(crmmap) {
        this.crmmap = crmmap;
        this.Status = new Status(crmmap);
        this.Items = new Items(crmmap);
        this.Icons = new Icons(crmmap);
        this.Contacts = new Contacts(crmmap);
        this.Features = new Features(crmmap);
        this.Categories = new Categories(crmmap);
        this.Routes = new Routes(crmmap);
        this.Users = new Users(crmmap);
        this.Terms = new Terms(crmmap);  //look at forcing a refresh
        this.Forms = new Forms(crmmap); 


        this.Icons.when('invaledate', () => {
            this.crmmap.refreshLegend();
        })
        this.Status.when('invaledate', () => {
            this.crmmap.refreshLegend();
        })
        this.Items.when('invaledate', () => {
            this.crmmap.refreshLegend();
        })
        this.Categories.when('invaledate', () => {
            this.crmmap.refreshLegend();
        })

        this.Contacts.when('invaledate', () => {
            this.crmmap.Contacts.updateTable();
        })


        
    /*     window.setTimeout(
            ()=>{

                //Only preload if on map page
                if (this.crmmap.Map && this.crmmap.Map.map)
                    this.preload();
            }
        , 5000); */

    }


    async preload() {
        await this.Contacts.get().then(console.log);
        await this.Items.get().then(console.log);
        await this.Status.get().then(console.log);
        await this.Categories.get().then(console.log);        
    }
}